/* Videos sin sonido · v2: política compartida, lazy-load y controles propios, nunca barra nativa. */
(function () {
  'use strict';
  if (window.DTVideos) { window.DTVideos.mount(document); return; }
  var root = document.documentElement || document;
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var listeners = new Set(), instances = new Map(), serial = 0, globalPaused = false;
  var selector = 'video[data-src], video[data-hero-video], video[data-pdp-video]';
  function forced() { return !!(root.getAttribute && root.getAttribute('data-movimiento') === 'forzado'); }
  function reduced() { return mq.matches && !forced(); }
  function notify() { listeners.forEach(function (fn) { fn(); }); }
  var policy = window.DTMotion = {
    forced: forced, reduced: reduced,
    paused: function () { return globalPaused; },
    quiet: function () { return reduced() || globalPaused; },
    subscribe: function (fn) { listeners.add(fn); return function () { listeners.delete(fn); }; },
    refresh: notify,
    setPaused: function (value) {
      globalPaused = !!value;
      if (root.setAttribute) {
        if (globalPaused) root.setAttribute('data-movimiento-pausado', 'true');
        else root.removeAttribute('data-movimiento-pausado');
      }
      notify();
    }
  };
  if (mq.addEventListener) mq.addEventListener('change', notify);
  else if (mq.addListener) mq.addListener(notify);
  function each(scope, fn) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches(selector)) fn(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(selector), fn);
  }
  function mount(v) {
    if (instances.has(v)) return;
    var visible = false, io = null, manualPlaying = false, userPaused = v.hasAttribute('data-pausado'), blocked = false;
    var registered = [], ownsButton = false;
    // Revisión v2 (15-oct): cada intento de play() lleva un número. Una promesa vieja (pausada, cambiada de fuente o de otra
    // instancia) ya no puede bloquear ni pausar lo que está pasando ahora; y una instancia destruida no vuelve a reproducir.
    var attempt = 0, destroyed = false;
    var shell = v.closest ? (v.closest('[data-video-shell]') || v.closest('figure') || v.closest('.shopify-section')) : null;
    var clone = v.closest && v.closest('[data-cinta-clone]');
    var button = shell && shell.querySelector ? shell.querySelector('[data-video-toggle]') : null;
    if (!button && v.hasAttribute('data-hero-video') && shell && shell.querySelector) button = shell.querySelector('[data-hero-pausa]');
    if (!button && !clone && shell && shell.appendChild && document.createElement) {
      button = document.createElement('button'); button.type = 'button'; button.className = 'dt-video-control';
      button.setAttribute('data-video-toggle', ''); shell.appendChild(button); ownsButton = true;
    }
    if (!v.getAttribute('id')) v.setAttribute('id', 'dt-video-' + (++serial));
    v.controls = false; v.removeAttribute('controls'); v.muted = true; v.defaultMuted = true;
    v.loop = true; v.playsInline = true; v.autoplay = true;
    v.setAttribute('muted', ''); v.setAttribute('loop', ''); v.setAttribute('playsinline', '');
    function on(target, event, fn) { target.addEventListener(event, fn); registered.push([target, event, fn]); }
    function inactive() { return v.hidden || (v.closest && !!v.closest('[hidden]')) || v.getAttribute('data-gallery-active') === 'false'; }
    function label() {
      if (!button || destroyed) return;
      button.hidden = !!clone || !v.paused || !(reduced() || !io || blocked) || globalPaused;
      button.disabled = globalPaused;
      button.setAttribute('aria-controls', v.getAttribute('id'));
      button.setAttribute('aria-pressed', String(!v.paused));
      button.setAttribute('aria-label', 'Reproducir video: ' + (v.getAttribute('aria-label') || 'escena de la rutina'));
      button.textContent = 'Reproducir video';
    }
    function pause() { attempt++; if (!v.paused) v.pause(); label(); }
    function allowed() {
      return !destroyed && visible && !document.hidden && !inactive() && !globalPaused && !userPaused &&
        (!reduced() || manualPlaying) && (!!io || manualPlaying) && (!blocked || manualPlaying);
    }
    function evaluate() {
      if (destroyed) return;
      if (v.isConnected === false) { var self = instances.get(v); if (self) self.destroy(); return; }
      v.controls = false;
      if (!visible || document.hidden || inactive()) manualPlaying = false;
      if (!allowed()) { pause(); return; }
      if (!v.getAttribute('src')) { var src = v.getAttribute('data-src'); if (!src) { label(); return; } v.src = src; }
      if (!v.paused) { label(); return; }
      var mine = ++attempt;
      var result = v.play();
      if (result && result.catch) result.catch(function (error) {
        if (destroyed || mine !== attempt) return;                 // promesa vieja: ya no gobierna al video
        if (error && error.name === 'AbortError') return;          // cancelación esperada (pause/cambio de fuente), no es un bloqueo
        blocked = true; manualPlaying = false; pause();            // el navegador exige un gesto: queda el botón propio
      });
      label();
    }
    if (button) on(button, 'click', function () {
      if (v.paused) { manualPlaying = true; userPaused = false; blocked = false; v.removeAttribute('data-pausado'); evaluate(); }
    });
    on(v, 'pause', label);
    on(v, 'play', function () { if (!allowed()) pause(); else label(); });
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (destroyed) return;
        entries.forEach(function (entry) { if (entry.target === v) { visible = entry.isIntersecting; evaluate(); } });
      }, { threshold: 0.15 });
      io.observe(v);
    } else { visible = true; }
    instances.set(v, {
      evaluate: evaluate,
      destroy: function () {
        destroyed = true; visible = false; pause(); if (io) io.disconnect();
        registered.forEach(function (item) { item[0].removeEventListener(item[1], item[2]); });
        if (ownsButton && button.remove) button.remove();
        instances.delete(v);
      }
    });
    evaluate();
  }
  function refresh() { instances.forEach(function (item) { item.evaluate(); }); }
  function destroy(scope) { each(scope, function (v) { var item = instances.get(v); if (item) item.destroy(); }); }
  window.DTVideos = { mount: function (scope) { each(scope, mount); }, destroy: destroy, refresh: refresh };
  policy.subscribe(refresh);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', function (event) { each(event.target, mount); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
  var toggle = document.querySelector ? document.querySelector('[data-dt-motion-pausa]') : null;
  if (toggle) {
    toggle.hidden = false;
    toggle.addEventListener('click', function () { policy.setPaused(!globalPaused); });
    policy.subscribe(function () { toggle.setAttribute('aria-pressed', String(globalPaused)); toggle.textContent = globalPaused ? 'Reanudar movimiento' : 'Pausar movimiento'; toggle.setAttribute('title', toggle.textContent); });
  }
  each(document, mount);
}());
